import { render } from "./AutoLimitLog.vue?vue&type=template&id=22e25376&ts=true"
import script from "./AutoLimitLog.vue?vue&type=script&lang=ts"
export * from "./AutoLimitLog.vue?vue&type=script&lang=ts"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__